<template>
  <dl class="sm:divide-y sm:divide-gray-200">
    <slot />
  </dl>
</template>
